import { observable, action } from 'mobx'
import { ERROR_CODES, LOCAL_STORAGE, PAGE_SIZE, STATUS_LOGIN } from '../helpers/constants'
import api from '../common/api'
import { showMessageError } from 'src/helpers/functions'
import { responseDefault } from './store.constants'
import moment from 'moment'
import { Request3 } from 'src/common/Request3'

export class AuthStore {
   @observable navCollapsed: boolean = true
   @observable width_screen: number = window.innerWidth
   @observable token: string = ''
   @observable isLogin: number = STATUS_LOGIN.WAIT_LOGIN
   @observable data_listCity: any = []
   @observable data_listDistrict: any = []
   @observable data_listVillage: any = []
   @observable data_role: string = ''

   @observable data_getUserInfo: any = {}
   @observable transactionHistory: any = { ...responseDefault }

   @observable data_detailUser: any = {}
   @observable isOpenAddJobDetail: boolean = false

   @action
   async action_OpenAddJobDetail() {
      this.isOpenAddJobDetail = true
   }

   @action
   async action_HideAddJobDetail() {
      this.isOpenAddJobDetail = false
   }

   @action
   async action_openSidebar() {
      this.navCollapsed = !this.navCollapsed
   }

   @action
   async action_closeSidebar() {
      this.navCollapsed = !this.navCollapsed
   }

   @action
   async action_loginUser(phoneNumber: string, password: string, rememberMe: any) {
      const body = {
         phoneNumber,
         password
      }
      console.log('nody :', body)

      const result = await Request3.post(api.auth.login, body)

      //console.log('====================================')
      console.log('result', result, ' ----', result?.code)

      if (result?.code == ERROR_CODES.SUCCESS) {
         const dataAuth = {
            tokens: result?.data?.tokens,
            refreshToken: result?.data?.tokens?.refresh?.token,
            expiresIn: moment().add(result?.data?.tokens?.access?.expires || 0, 'seconds'),
            refreshExpiresIn: moment().add(result?.data?.token?.refresh?.expires || 0, 's')
         }
         this.data_role = result?.data?.account?.role || ''
         this.data_getUserInfo = result?.data?.account || {}
         console.log('dataAuth login', dataAuth)
         await localStorage.setItem(LOCAL_STORAGE.REMEMBER_ME, JSON.stringify(rememberMe))

         await localStorage.setItem(LOCAL_STORAGE.DATA_AUTH, JSON.stringify(dataAuth))
         // if (rememberMe === true) {
         //    await localStorage.setItem(LOCAL_STORAGE.DATA_AUTH, JSON.stringify(dataAuth))
         // } else {
         //    await sessionStorage.setItem(LOCAL_STORAGE.DATA_AUTH, JSON.stringify(dataAuth))
         // }
         this.isLogin = STATUS_LOGIN.LOGIN_SUCCESS
      }

      return result
   }
   @action
   async action_register(params: any, role: any) {
      const result = await Request3.post(api.auth.register, { ...params, ...role })
      return result
   }

   @action
   async action_updateProfiles(params: any) {
      const result = await Request3.putWithToken(api.user.updateProfile, { ...params })
      if (result) {
         // this.data_getUserInfo = result?.data
         this.action_getProfile() //check tạm để cho chạy đúng
         return result
      }
      return false
   }

   @action
   async action_updateAvatar(file: any) {
      const result = await Request3.uploadFile(file, api.upload.uploadFile)
      if (result?.code !== ERROR_CODES.SUCCESS) return false
      const res = await this.action_updateProfiles({ avatar: result?.data?.filename })
      if (res?.code === ERROR_CODES.SUCCESS) {
         return res
      }
      return false
   }

   @action
   async action_uploadImage(fileName: any, fileData: any) {
      // const DOMAIN = `${CONFIG_URL.SERVICE_URL}/${WsCode.uploadImg}`;

      // const json = {
      //    fileName,
      //    fileData
      // }

      // const result = await Request.post(WsCode.uploadImg, json, DOMAIN);
      const result = {
         url: ''
      }
      if (result) {
         return result.url
      }

      return false
   }

   @action
   async action_forgotPassword(params: any) {
      // console.log(params)
      const result = await Request3.post(api.auth.forgotPassword, { ...params })
      return result.data
   }

   @action
   async action_logout(history: any) {
      try {
         await Request3.post(api.auth.logout, {})
         await localStorage.removeItem(LOCAL_STORAGE.DATA_AUTH)
         await sessionStorage.removeItem(LOCAL_STORAGE.DATA_AUTH)
         this.data_role = ''
         this.isLogin = STATUS_LOGIN.NOT_LOGIN

         history?.push('/signin')
      } catch (error) {}
   }

   @action
   async action_getRole(history?: any) {
      const result = await Request3.getWithToken(api.user.getProfile)
      console.log('action_getRole', result)

      if (!result?.data) {
         this.data_getUserInfo = {}
         this.data_role = ''
         this.isLogin = STATUS_LOGIN.NOT_LOGIN
         await localStorage.removeItem(LOCAL_STORAGE.DATA_AUTH)
         history.push('/signin')
         return result
      } else {
         this.data_getUserInfo = result?.data
         this.data_role = result?.data?.role || ''
         // this.data_role = result.data?.account?.role || ''

         return true
      }
   }

   @action
   async action_getProfile() {
      const result = await Request3.getWithToken(api.user.getProfile)
      console.log('action_getProfile Request3.getWithToken', result)

      if (result?.data) {
         this.data_getUserInfo = result?.data
         this.data_role = result?.data?.roles || []
         return true
      }
   }
   @action
   async getTransaction(params: any = {}) {
      // @ts-ignore
      const result = await Request3.get(api.user.transaction, { ...params, ...{ limit: PAGE_SIZE } })
      if (result) {
         this.transactionHistory = result
         return true
      }
   }
   @action
   async action_verifyEmail(params: any) {
      // try {
      //    let client = await Request3.header()
      //    const res = await client.post(`${api.auth.verifyEmail}?token=${params}`, {})
      //    return res?.data
      // } catch (error: any) {
      //    if (error.message === 'Network Error') {
      //       showMessageError('Không có kết nối. Vui lòng thử lại')
      //    } else if (error.message.indexOf('timeout of') !== -1) {
      //    } else if (error.response?.data?.message === 'Error: Account not verify') {
      //       return { isAccountNotActive: true }
      //    } else {
      //       showMessageError(error.response?.data?.message)
      //    }
      // }
   }

   @action
   async action_resendVerifyEmail(params: any) {
      const result = await Request3.post(api.auth.sendEmail, params)
      return result
   }

   @action
   async action_resetPassword(params: any, token: string | null) {
      const result = await Request3.post(`${api.auth.resetPassword}?token=${token}`, params)
      return result.data
   }
}
